import { useAppSelector } from '../hooks/redux';
import {
  mapClassificationToRiskLevel,
  formatClassificationText
} from '../utils/Functions.utils';

export const useEUDeclarationData = () => {
  const { createEUDeclarationResponse } = useAppSelector(
    (state) => state.documentation
  );

  const footerData = {
    text: createEUDeclarationResponse?.footerNote?.text ?? '',
    email: 'compliai@skyhighgrowth.com',
    reportId: '',
    generatedBy: createEUDeclarationResponse?.footerNote?.generatedBy ?? ''
  };

  const headerData = {
    title: 'EU Declaration of Conformity',
    entityType: {
      label: 'Entity Type',
      value: createEUDeclarationResponse?.documentControl?.entityType ?? ''
    },
    systemName: {
      label: 'AI System Name',
      value: createEUDeclarationResponse?.documentControl?.aiSystemName ?? ''
    },
    version: {
      label: 'Version',
      value: createEUDeclarationResponse?.documentControl?.version ?? ''
    },
    organizationName: {
      label: 'Organization Name',
      value:
        createEUDeclarationResponse?.documentControl?.organizationName ?? ''
    },
    provider: {
      label: 'Compliance Contact Person',
      value:
        createEUDeclarationResponse?.documentControl?.complianceContactPerson ??
        ''
    },
    classification: {
      risk: mapClassificationToRiskLevel(
        createEUDeclarationResponse?.documentControl?.classification ?? ''
      ),
      text: formatClassificationText(
        createEUDeclarationResponse?.documentControl?.classification ?? ''
      )
    },
    generatedTime:
      createEUDeclarationResponse?.documentControl?.dateCreated ?? '',
    reportId: createEUDeclarationResponse?.documentControl?.documentId ?? '',
    labels: {
      generatedLabel: 'Date Created',
      idLabel: 'Document ID'
    }
  };

  return { headerData, footerData };
};
